import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Alert, Button } from 'antd';

import { warningsFactory } from 'v2/services/warning';

import NoDangerouslyHTML from '../NoDangerouslyHTML';

const matchesPageUrl = (pattern: string): boolean => {
  const regexPattern = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*');
  const regex = new RegExp(`^${regexPattern}$`);

  return regex.test(window.location.href);
};

const GlobalWarning = () => {
  const [answeredWarnings, setAnsweredWarnings] = useState([]);
  const [warnings] = useObservable(() => warningsFactory.getWarnings(), []);

  const warningsNotAnswered =
    warnings?.filter(warning => {
      if (answeredWarnings.includes(warning.id)) return false;

      if (!warning.pages?.length) return true;

      return warning.pages.some(page => matchesPageUrl(page.url));
    }) || [];

  const closeAlert = (id: string) => {
    const newAnsweredWarnings = [...answeredWarnings, id];
    localStorage.setItem('warnings', newAnsweredWarnings.toString());
    setAnsweredWarnings(newAnsweredWarnings);
  };

  const shouldShowCloseButton = (id: string) => {
    const notShow = ['eb3bf692-57e9-4cb0-88f0-2afd24380212'];

    return !notShow.includes(id);
  };

  useEffect(() => {
    const storage = localStorage.getItem('warnings');
    setAnsweredWarnings(storage?.split(',') || []);
  }, []);

  if (!warningsNotAnswered?.length) return null;

  return (
    <>
      {warningsNotAnswered.map(warning => (
        <>
          <Alert
            key={warning.id}
            type={warning.type}
            showIcon
            message={<b>{warning.title}</b>}
            description={<NoDangerouslyHTML html={warning.description} />}
            action={
              <div className='flex gap-1'>
                {!!warning.link && (
                  <Button href={warning.link} target='_blank' aria-label='saiba mais'>
                    Saiba mais
                  </Button>
                )}
                {shouldShowCloseButton(warning.id) && (
                  <Button onClick={() => closeAlert(warning.id)} aria-label='fechar'>
                    Entendi
                  </Button>
                )}
              </div>
            }
          />
          <div className='mt-2' />
        </>
      ))}
    </>
  );
};

export default GlobalWarning;
